import { render } from "./BookmarkList.vue?vue&type=template&id=5ac05358&scoped=true"
import script from "./BookmarkList.vue?vue&type=script&lang=js"
export * from "./BookmarkList.vue?vue&type=script&lang=js"

import "./BookmarkList.vue?vue&type=style&index=0&id=5ac05358&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac05358"]])

export default __exports__